import { Box, AnimationHeadShake, Metrics, Colors } from '@origin-digital/style-guide';
import { ErrorMessage } from 'formik';
import React from 'react';
import styled from 'styled-components';

import { FieldErrorProps } from './FieldError.types';

const { FontWeights } = Metrics;
const ErrorContainer = styled(Box)`
  margin-right: 12px;
  margin-top: 12px;
  line-height: 20px;
  font-size: 12px;
  line-height: 20px;
  font-weight: ${FontWeights.REGULAR};
  color: ${Colors.RED};
`;

const FieldError: React.StatelessComponent<FieldErrorProps> = ({
  ...props
}: FieldErrorProps): JSX.Element | null => {
  const { error, name } = props;

  if (!error) {
    return null;
  }

  return (
    <ErrorContainer display="block">
      <AnimationHeadShake data-id={name + 'Error'} duration="0.8s" delay="0">
        <ErrorMessage key={error} name={error} />
      </AnimationHeadShake>
    </ErrorContainer>
  );
};

export { FieldError as default };
